import { render } from "./IStarComponent.vue?vue&type=template&id=7fac607a"
import script from "./IStarComponent.vue?vue&type=script&lang=js"
export * from "./IStarComponent.vue?vue&type=script&lang=js"

import "./IStarComponent.vue?vue&type=style&index=0&id=7fac607a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__